<template>
  <div id="makeSurePas_phone">
    <div class="content">
      <!-- <div class="dialog-title">{{ dialogData.title }}</div> -->
      <!-- 申请状态:验证身份,重置密码 -->
      <!-- <div class="verification">
        <div class="verification_outer">
          <div class="ver3"></div>
          <div class="ver1">
            <div class="ver1_l">
              <div class="ver1_l_c"></div>
            </div>
            <div class="ver1_center"></div>
            <div class="ver1_l">
              <div class="ver1_l_c"></div>
            </div>
          </div>
          <div class="ver2">
            <span>验证身份</span>
            <span>重置密码</span>
          </div>
        </div>
      </div> -->
      <!--  -->
      <div class="top">
        <div class="topTitle">{{ dialogData.title }}</div>
        <div class="box">
          <div class="one">
            <div class="oneo"></div>
          </div>
          <div class="two"></div>
          <div class="three">
            <div class="oneo"></div>
          </div>
        </div>
        <div class="state">
          <span>验证身份</span>
          <span>重置密码</span>
        </div>
      </div>

      <!--  -->
      <div class="dialog-content customScrollBar">
        <div class="line" v-for="(item, index) in dialogData.data" :key="index">
          <div class="title">
            {{ item.name }}<span v-if="!item.isNull">*</span>
          </div>
          <div class="value" v-if="item.type == 'input'">
            <el-input
              v-model="item.value"
              :placeholder="'请输入' + item.name"
              show-password
            ></el-input>
          </div>
          <!-- 获取手机验证码 -->
          <div class="value" v-if="item.type == 'input-yzm'">
            <el-input
              v-model="item.value"
              :placeholder="'请输入' + item.name"
            ></el-input>
            <div class="yzm" @click="getCode">获取验证码</div>
          </div>
          <div class="value" v-if="item.type == 'input-btn'">
            <el-input
              v-model="item.value"
              :placeholder="'请输入' + item.name"
            ></el-input>
            <div class="yzm" @click="getCode">获取验证码</div>
          </div>
        </div>
        <div class="dialog-but">
          <div class="title"></div>
          <div class="valuebtn" @click="reset">
            <span>{{ dialogData.btnName }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "makeSurePas_phone",
  props: {
    makeSurePasData: {
      type: Object,
      default: function () {
        return {
          flag: true,
          title: "注册",
          data: [],
        };
      },
    },
  },
  data() {
    return {
      dialogData: this.makeSurePasData,
    };
  },
  methods: {
    reset() {
      this.$emit("reset");
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
#makeSurePas_phone {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  // justify-content: space-around;
  .content {
    border-radius: 10px;
    width: 100%;
    height: 70%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    background: rgba(255, 255, 255, 1);
    padding: 50px 10px 0 10px;
    .dialog-title {
      width: 80%;
      height: 50px;
      line-height: 50px;
      font-size: 14px;
      font-weight: 700;
    }
    .top {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 14px;
      border-bottom: 1px solid rgba(245, 245, 245, 1);
      .topTitle {
        width: 100%;
        display: flex;
        justify-content: center;
        font-size: 14px;
        margin-bottom: 25px;
      }
      .box {
        width: 90%;
        display: flex;
        align-items: center;
        .one {
          width: 15px;
          height: 15px;
          border-radius: 50%;
          background: rgba(152, 188, 255, 1);
          display: flex;
          justify-content: center;
          align-items: center;
          .oneo {
            width: 9px;
            height: 9px;
            border-radius: 50%;
            background: rgba(51, 125, 255, 1);
          }
        }
        .two {
          flex: 1;
          height: 8px;
          background: rgba(224, 241, 255, 1);
        }
        .three {
          width: 15px;
          height: 15px;
          border-radius: 50%;
          background: rgba(152, 188, 255, 1);
          display: flex;
          justify-content: center;
          align-items: center;
          .oneo {
            width: 9px;
            height: 9px;
            border-radius: 50%;
            background: rgba(51, 125, 255, 1);
          }
        }
      }
      .state {
        width: 100%;
        margin: 16px 0;
        display: flex;
        justify-content: space-between;
        > span {
          font-size: 14px;
        }
      }
    }
    // .verification {
    //   width: 100%;
    //   height: 3.75rem;
    //   display: flex;
    //   justify-content: center;
    //   .verification_outer {
    //     width: 90%;
    //     display: flex;
    //     flex-direction: column;
    //     justify-content: space-around;
    //     align-items: center;

    //     .ver1 {
    //       width: 84%;
    //       display: flex;
    //       align-items: center;
    //       .ver1_l {
    //         width: 15px;
    //         height: 15px;
    //         border-radius: 50%;
    //         background: rgba(152, 188, 255, 1);
    //         display: flex;
    //         justify-content: center;
    //         align-items: center;

    //         .ver1_l_c {
    //           width: 9px;
    //           height: 9px;
    //           border-radius: 50%;
    //           background: rgba(51, 125, 255, 1);
    //         }
    //       }
    //       .ver1_center {
    //         flex: 1;
    //         height: 8px;
    //         background: rgba(224, 241, 255, 1);
    //       }
    //     }
    //     .ver2 {
    //       width: 100%;
    //       display: flex;
    //       margin-top: 15px;
    //       justify-content: space-between;
    //     }
    //   }
    // }
    .dialog-content {
      width: 100%;
      height: 90%;
      box-sizing: border-box;
      padding: 0 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .line {
        width: 96%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        margin-top: 10px;
        .title {
          font-size: 14px;
          margin-bottom: 10px;
          > span {
            color: red;
          }
        }
        .value {
          width: 100%;
          height: 43px;
          position: relative;
          .yzm {
            position: absolute;
            right: 10px;
            top: 12px;
            color: rgba(0, 79, 148, 1);
            font-size: 14px;
            font-weight: 400;
            &:hover {
              cursor: pointer;
              color: rgb(7, 132, 241);
            }
          }
        }
      }
      .dialog-but {
        width: 100%;
        height: 2.8125rem;
        box-sizing: border-box;
        margin-top: 20px;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        margin-top: 50px;
        .valuebtn {
          width: 96%;
          height: 43px;
          background: rgba(7, 80, 139, 1);
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 8px;
          &:hover {
            cursor: pointer;
          }
          > span {
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
